import React from 'react';
import loader from 'ui/illustrations/CW_line_loader.svg';

// Lives apart from AuthenticatedRoutes so logged-out pages can show it without loading the logged-in shell
export function LoadingScreen() {
  return (
    <div className="u-flex-center u-flex-align-center" style={{ height: '80vh' }}>
      <img style={{ height: '10vh', maxHeight: 80, minHeight: 50 }} src={loader} />
    </div>
  );
}
